import {CanActivateFn, Router} from '@angular/router';
import {AuthService} from "../_services/auth.service";
import {inject} from "@angular/core";
import {filter, map, Observable, take} from "rxjs";

export const AdminGuard: CanActivateFn = (route, state): Observable<boolean> => {
    const authService: AuthService = inject(AuthService);
    const router: Router = inject(Router);

    return authService.getUser().pipe(
        filter(user => !!user),
        take(1),
        map(user => {
            if (user?.role?.role_type !== 'admin') {
                router.navigate(['/timeline']);
                return false;
            }
            return true;
        })
    );
}
